import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, InputAdornment, Tabs, Tab, Paper } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
import toast from "react-hot-toast";
import { get } from "../../utility/fetch";
import Articles from "./Articles";
import AllNotification from "./AllNotification";
// import Spinner from "../Spinner";
import { FaSearch } from "react-icons/fa";
import Spinner from "../UI/Spinner";

const NotificationPage = () => {
    const [activeFilter, setActiveFilter] = useState("All");
    const [searchTerm, setSearchTerm] = useState("");
    const [notification, setNotification] = useState([]);
    const [loading, setLoading] = useState(true);

    const staticNotifications = [
        {
            id: 1,
            user: "Gabriel William",
            action: "Granted access to",
            group: "FITNESS PLUS GROUP",
            time: "Today at 9:42 AM",
        },
        {
            id: 2,
            user: "Ray Arnold",
            action: "left 6 comments on",
            group: "BODY FITNESS GROUP",
            time: "Last Wednesday at 9:42 AM",
        },
        {
            id: 3,
            user: "Denise Nedry",
            action: "replied to",
            group: "Anna Szrand",
            comment:
                "Oh, I finished de-bugging the phones, but the system's compiling for eighteen minutes, or twenty.",
            time: "Last Wednesday at 9:42 AM",
        },
    ];

    const getNotification = async (filter) => {
        setLoading(true);
        try {
            let endpoint;
            if (filter === "All") {
                endpoint = "/Notification";
            } else if (filter === "Article") {
                endpoint = "/Articles?featuredOnly=false&page=1&pageSize=10";
            } else {
                endpoint = `/Notification/${filter.toLowerCase()}`;
            }

            const response = await get(endpoint);
            if (response.code === 200) {
                setNotification(response?.data);
            } else {
                toast.error("Error fetching notifications");
            }
        } catch (error) {
            toast.error("Error fetching notifications");
            console.error(error);
        }
        setLoading(false);
    };

    useEffect(() => {
        getNotification(activeFilter);
    }, [activeFilter]);

    const handleSearchChange = (e) => setSearchTerm(e.target.value);

    const handleTabChange = (_, newValue) => {
        setActiveFilter(newValue);
    };

    return (
        <Box className="m-t-40" sx={{ maxWidth: 800, mx: "auto", p: 3 }}>
            <Typography variant="h4" gutterBottom>
                Notifications
            </Typography>

            <TextField
                fullWidth
                placeholder="Search for Notification"
                value={searchTerm}
                onChange={handleSearchChange}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <FaSearch />
                        </InputAdornment>
                    ),
                }}
                sx={{ mb: 3 }}
            />

            <Paper elevation={1} sx={{ mb: 3 }}>
                <Tabs
                    value={activeFilter}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    indicatorColor="primary"
                    textColor="primary"
                >
                    {["All", "Appointment", "Community", "Article"].map((filter) => (
                        <Tab key={filter} label={filter} value={filter} />
                    ))}
                </Tabs>
            </Paper>

            {loading ? (
                <Spinner />
            ) : activeFilter === "Article" ? (
                <Articles articles={notification} />
            ) : (
                <AllNotification articles={staticNotifications} />
            )}
        </Box>
    );
};

export default NotificationPage;
